module.exports = __webpack_public_path__ + "img/第1章_2-4_名片與簽名.jpg";